import { RegisterOptions } from "react-hook-form";

import { SelectOptionTypes } from "../../../../components/Input";
import { AmountVariant } from "../../../../utils/tone";
import { TransactionTypeOptions } from "../../../Transactions";
import { ProgressType } from "./types";

export const FORM_ID = "progress";

export const TYPE_OPTIONS = [
  { label: "Market Update", value: TransactionTypeOptions.MARKET_UPDATE },
  { label: "Transfer In", value: TransactionTypeOptions.TRANSFER_IN },
  { label: "Transfer Out", value: TransactionTypeOptions.TRANSFER_OUT },
] as SelectOptionTypes[];

// Compact labels for the type segmented control (three across one row).
export const SEGMENT_LABELS: Record<string, string> = {
  [TransactionTypeOptions.MARKET_UPDATE]: "Update",
  [TransactionTypeOptions.TRANSFER_IN]: "In",
  [TransactionTypeOptions.TRANSFER_OUT]: "Out",
};

export const TONE_BY_TYPE: Record<string, AmountVariant> = {
  [TransactionTypeOptions.MARKET_UPDATE]: "neutral",
  [TransactionTypeOptions.TRANSFER_IN]: "income",
  [TransactionTypeOptions.TRANSFER_OUT]: "expense",
};

export const AMOUNT_RULES: RegisterOptions<ProgressType> = {
  required: "Amount is required",
  min: { value: 0.01, message: "Amount must be greater than 0" },
};

export const accountTypeToStringMap: Record<string, string> = {
  [TransactionTypeOptions.MARKET_UPDATE]: "Market Update",
  [TransactionTypeOptions.TRANSFER_IN]: "Transfer In",
  [TransactionTypeOptions.TRANSFER_OUT]: "Transfer Out",
};

export const accountTypeToValueMap: Record<string, TransactionTypeOptions> = {
  "Market Update": TransactionTypeOptions.MARKET_UPDATE,
  "Transfer In": TransactionTypeOptions.TRANSFER_IN,
  "Transfer Out": TransactionTypeOptions.TRANSFER_OUT,
};

export const DEFAULT_PROGRESS: ProgressType = {
  amount: "",
  transactionType: TYPE_OPTIONS[0],
  fromAccount: null,
  toAccount: null,
  transactionDate: new Date(),
  note: "",
};
